import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { SettingsProvider } from "@/context/SettingsContext";

// Layout
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import BookingModal from "@/components/BookingModal";
import ScrollToTop from "@/components/ScrollToTop";

// Pages
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import TaxPrep from "@/pages/TaxPrep";
import Bookkeeping from "@/pages/Bookkeeping";
import Business from "@/pages/Business";
import NonProfit from "@/pages/NonProfit";
import Notary from "@/pages/Notary";
import Resources from "@/pages/Resources";
import BlogPost from "@/pages/BlogPost";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Portal from "@/pages/Portal";
import StartReturn from "@/pages/StartReturn";
import AIAutomation from "@/pages/AIAutomation";
import EntityFormation from "@/pages/EntityFormation";
import Payments from "@/pages/Payments";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Accessibility from "@/pages/Accessibility";
import Consent from "@/pages/Consent";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <SettingsProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main className="min-h-screen">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/tax-prep" element={<TaxPrep />} />
            <Route path="/bookkeeping" element={<Bookkeeping />} />
            <Route path="/business" element={<Business />} />
            <Route path="/nonprofit" element={<NonProfit />} />
            <Route path="/notary" element={<Notary />} />
            <Route path="/start" element={<StartReturn />} />
            <Route path="/ai-automation" element={<AIAutomation />} />
            <Route path="/entity-formation" element={<EntityFormation />} />
            <Route path="/payments" element={<Payments />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/accessibility" element={<Accessibility />} />
            <Route path="/consent" element={<Consent />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/resources/:slug" element={<BlogPost />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/portal" element={<Portal />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </main>
        <Footer />
        <BookingModal />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
      </SettingsProvider>
    </div>
  );
}

export default App;
